(ns frontend.view.modals.curtains.column-selector-curtain.view
  (:require
   [common.attribute :as attribute]
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [frontend.workaround :as wr]
   [reagent.core :as r]
   [ui.components.modal.view :as modal]
   [ui.components.toggle.view :as toggle]
   [ui.util :as uu]))

(defonce modal-key :curtain/column-selector)

(defn select-tab!
  [state tab-key]
  (swap! state assoc :selected-tab tab-key))

(defn view
  [{:keys [state props _shown? _close-modal! _topmost?]}]
  (let [error-state (r/cursor state [:error-text])
        modal-state state
        {:keys [state fields-getter column-tabs]} props
        field-values-by-key (when (and state fields-getter)
                              (->> (fields-getter @state)
                                   (map (fn [field]
                                          [(:field/key field) (:field/value field)]))
                                   (into {})))
        has-tabs? (seq column-tabs)]
    (when has-tabs?
      (select-tab! modal-state
                   (->> column-tabs
                        first
                        :key)))
    (fn [{:keys [shown? topmost? close-modal! props]}]                                              ;; modals generated state overridden with parameter on purpose
      (let [{:keys [header-text state fields-getter column-tabs resolve-tab on-save! on-change!]} props
            fields (when (and state fields-getter)
                     (fields-getter @state))
            changes? (->> fields
                          (remove (fn [field]
                                    (= (:field/value field)
                                       (get field-values-by-key (:field/key field)))))
                          (seq))
            tenant-schema @session/tenant-schema
            selected-tab (:selected-tab @modal-state)
            has-tabs? (seq column-tabs)
            filter-by-tab? (and has-tabs?
                                (fn? resolve-tab))
            fields (if-not filter-by-tab?
                     fields
                     (->> fields
                          (filter (fn [field]
                                    (let [attribute (:field/key field)
                                          t (resolve-tab attribute)]
                                      (= t
                                         selected-tab))))))
            partitioned (->> fields
                             (partition-by (fn [field]
                                             (let [a (:field/key field)]
                                               (if (sequential? a)
                                                 (first a)
                                                 false)))))
            fields-with-subheaders
            (->> partitioned
                 (mapcat (fn [partition]
                           (let [field (first partition)
                                 a (:field/key field)]
                             (if (sequential? a)
                               (vec (concat [{:field/subheader? true
                                              :field/name       (loc/tr :fields-subheader
                                                                  [(attribute/attribute-label
                                                                    tenant-schema
                                                                    (first a))])
                                              :field/key        [:subheader (first a)]}]
                                            partition))
                               partition)))))
            fields (if filter-by-tab?
                     fields
                     fields-with-subheaders)
            close! (fn [_]
                     (when on-save!
                       (on-save!))
                     (close-modal!))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? (not on-save!)}
         header-text
         [:<>
          (when @error-state
            [:div
             {:class "bg-danger-light"}
             (str @error-state)])
          [:div
           {:class "flex gap-8"}

           (when has-tabs?
             [:div
              {:class "w-1/4"}
              [:ul
               {:class "flex flex-col gap-4"
                :id    "column-selector-tabs"}
               (doall
                (for [tab column-tabs
                      :let [tab-key (:key tab)
                            label (:label tab)]]
                  ^{:key (str "colum-tab-" tab-key)}
                  [:li
                   {:class    (uu/cm "py-2 font-bold cursor-pointer"
                                     (when (= selected-tab tab-key)
                                       "border-b border-solid !border-base-light-border-accent"))
                    :on-click (fn [_]
                                (swap! modal-state assoc :selected-tab tab-key))}
                   label]))]])

           [:div
            {:class "flex-1"}
            [:form
             (doall
              (for [field fields
                    :let [subheader? (:field/subheader? field)]]
                [:div
                 {:key   (str "select-curtain-row-"
                              (wr/key->js-workaround (:field/key field))
                              (when subheader? "-subheader"))
                  :class "py-2 flex justify-between items-center border-b border-solid border-base-light-border-paler"}
                 [:div
                  [:div
                   (:field/name field)]]
                 [:div
                  [:div
                   (when-not subheader?
                     (let [checked? (:field/value field)]
                       [:div
                        {:key (str "select-curtain-" (:field/name field) "-switch")}

                        [toggle/toggle
                         {:checked?  checked?
                          :disabled? (:field/disabled? field)
                          :on-change (fn [_e]
                                       (on-change! (:field/key field) (not checked?)))}]]))]]]))]]]]
         (when on-save!
           [:<>
            [modal/left-cancel-only close-modal! nil]
            [modal/right-single-button
             nil
             (not changes?)
             close!
             (loc/tr :save)
             nil]])]))))
